import { ArrowRight } from "lucide-react";
import { useReveal } from "../../lib/reveal";

const ORC_LINK = "https://mautic.remindbrindes.com.br/metiercomlporc1";

export default function ContactCTA() {
  const { ref, visible } = useReveal();

  return (
    <section
      id="contato"
      ref={ref}
      data-testid="contato-section"
      className="py-24 md:py-32 relative overflow-hidden"
      style={{ backgroundColor: "#0B2E24", color: "#FAFAFA" }}
    >
      <div className="grain absolute inset-0" aria-hidden="true" />
      <div className="relative max-w-5xl mx-auto px-6 md:px-12 text-center">
        <p className={`overline reveal ${visible ? "in" : ""}`}>Vamos conversar</p>

        <h2
          className={`font-serif font-light text-4xl md:text-5xl lg:text-6xl tracking-tight text-[#FAFAFA] mt-6 leading-[1.02] max-w-4xl mx-auto reveal ${visible ? "in" : ""}`}
          style={{ transitionDelay: "80ms" }}
        >
          Eleve o posicionamento <em className="italic text-[#C5A059]">premium</em> do seu programa.
        </h2>

        <p
          className={`mt-8 text-base md:text-lg text-[#FAFAFA]/75 font-light leading-relaxed max-w-2xl mx-auto reveal ${visible ? "in" : ""}`}
          style={{ transitionDelay: "160ms" }}
        >
          Conte sobre seu curso, o momento da jornada e o volume estimado. Nossa curadoria entra
          em contato com uma proposta personalizada em até 1 dia útil.
        </p>

        <div
          className={`mt-14 flex flex-col items-center gap-5 reveal ${visible ? "in" : ""}`}
          style={{ transitionDelay: "240ms" }}
        >
          <p
            className="font-serif italic text-2xl md:text-3xl text-[#C5A059]"
            data-testid="cta-tagline"
          >
            Click aqui!
          </p>

          <a
            href={ORC_LINK}
            target="_blank"
            rel="noreferrer"
            data-testid="mautic-cta-button"
            className="btn-gold text-center"
            style={{ padding: "20px 40px", fontSize: "0.85rem", letterSpacing: "0.14em", maxWidth: "100%" }}
          >
            <span className="whitespace-normal md:whitespace-nowrap">
              Deixe o seu contato — vamos construir uma parceria de resultados
            </span>
            <ArrowRight size={18} className="shrink-0" />
          </a>

          <div className="mt-10 pt-8 border-t border-[rgba(250,250,250,0.15)] w-full max-w-md">
            <p className="overline text-[#C5A059] mb-3">Atendimento MetierCom</p>
            <p className="text-sm text-[#FAFAFA]/85">www.metiercom.com.br</p>
            <p className="text-sm text-[#FAFAFA]/85">Seg a Sex · 09h às 18h</p>
          </div>
        </div>
      </div>
    </section>
  );
}
